import { debounce } from 'lodash';

export const shortDebouncedCallback = debounce((param, callback) => callback(param), 100);
